// @flow
import $ from 'jquery';

import JQueryView, { on } from '../common/JQueryView';
import previewImageHelper from '../../helpers/previewImageHelper';

export default class ApplicationView extends JQueryView {
  firstLogin: boolean;

  constructor() {
    super('body');
  }

  toggleSideMenuStatus = () => {
    if ($('.side-menu-collapsed').length) {
      document.cookie = 'collapsed=true';
    } else {
      document.cookie = 'collapsed=';
    }
  };

  @on({ event: 'click', selector: '.with-loading' })
  showLoadingComponent() {
    this.$el.submit();
    $('.loading').show();
  }

  @on({ event: 'change', selector: '#set_company_form .wrapper__selector' })
  changeCurrentCompany() {
    $('#set_company_form').submit();
    $('.loading').show();
  }

  @on({ event: 'click', selector: '.wrapper__nav-link' })
  changeWrapperLink(event: any) {
    $('.wrapper__nav-link').removeClass('wrapper__nav-link--active');
    $(event.currentTarget).addClass('wrapper__nav-link--active');
  }

  @on({ event: 'hidden.bs.modal', selector: '.modal' })
  checkModalOpen() {
    if ($('.modal.show').length > 0) $('body').addClass('modal-open');
    $('.modal.show').focus();
  }

  @on({ event: 'show.bs.modal', selector: '.modal' })
  changeModalZIndex(event: any) {
    const zIndex = 1040 + 10 * $('.modal:visible').length;
    $(event.currentTarget).css('z-index', zIndex);
    setTimeout(() => {
      $('.modal-backdrop')
        .not('.modal-stack')
        .css('z-index', zIndex - 1)
        .addClass('modal-stack');
    }, 0);
  }

  @on({ event: 'click', selector: 'self' })
  closeDialog(event: any) {
    this.closeSelectYearDialog(event);
  }

  @on({ event: 'keydown', selector: '.zip-code-field' })
  limitLengthOfZipCode(e: any) {
    if (e.target.value.indexOf('-') === -1 && e.target.value.length >= 7) {
      return false;
    }
    if (e.target.value.indexOf('-') !== -1 && e.target.value.length > 8) {
      return false;
    }
    return true;
  }

  @on({ event: 'keydown', selector: '.phone-number' })
  limitPhoneNumber(e: any) {
    if (
      (e.target.value.match(/-/g) || []).length === 0 &&
      e.target.value.length >= 11
    ) {
      return false;
    }
    if (
      (e.target.value.match(/-/g) || []).length === 1 &&
      e.target.value.length >= 12
    ) {
      return false;
    }
    if (
      (e.target.value.match(/-/g) || []).length === 2 &&
      e.target.value.length > 13
    ) {
      return false;
    }
    return true;
  }

  @on({
    event: 'drag dragstart dragend dragover dragenter dragleave drop',
    selector: '.change-image__preview',
  })
  dropFile(event: any) {
    event.preventDefault();
    event.stopPropagation();
    const { files } = event.originalEvent.dataTransfer;
    $('.choose-image').prop('files', files);
    previewImageHelper($('.choose-image'), $('.upload-image'));
  }

  @on({ event: 'hide.daterangepicker', selector: '.daterange-picker' })
  focusOnOpeningModal() {
    setTimeout(
      () =>
        $('body')
          .find('.modal.show')
          .focus(),
      0,
    );
  }

  @on({ event: 'click', selector: '.toggle-side-menu' })
  toggleSideMenu() {
    $('body').toggleClass('side-menu-collapsed');
    this.toggleSideMenuStatus();
  }

  @on({ event: 'click', selector: '.sidebar__sub-menu' })
  expandSideMenu() {
    if ($('.side-menu-collapsed').length)
      $('body').removeClass('side-menu-collapsed');
    this.toggleSideMenuStatus();
  }

  @on({ event: 'change', selector: '.input' })
  trimInput(event: any) {
    $(event.target).val(event.target.value.trim());
  }

  @on({ event: 'click', selector: '#open' })
  onClickMenuOpen() {
    $('#menu-open').addClass('hide');
    $('#menu-close, .overlay, .menu, .menu-sign-up').removeClass('hide');
  }

  @on({ event: 'click', selector: '#close' })
  onClickMenuClose() {
    $('#menu-open').removeClass('hide');
    $('#menu-close, .overlay, .menu, .menu-sign-up').addClass('hide');
  }

  closeSelectYearDialog(event: any) {
    const $selectYear = $('.select-year-wrapper__dialog');
    if (
      !$selectYear.is(event.target) &&
      $selectYear.parent().has(event.target).length === 0
    ) {
      $selectYear.hide();
    }
  }
}
